/* eslint-disable no-multi-assign */

import React from 'react'
import { useMemo, useMedia } from 'sb-hooks'
import vwx from 'common/helpers/modifiers/vwx'
import cx from 'classnames'

import s from './Skeleton.scss'


type SkeletonProps = {
  className?: string
  w?: number
  pw?: number
  ph?: number
  h?: number
  aspect?: number // w / h, e.g. 1.33
  color?: string
  circle?: boolean
  inline?: boolean
}

const Skeleton: React.FunctionComponent<SkeletonProps> = (props) => {
  const { className, w, pw, ph, h, aspect, circle, color = 'gray', inline = false } = props

  const { isMobile } = useMedia()

  const style = useMemo(() => {
    const style: any = {}

    if (w) {
      style.width = style.minWidth = isMobile ? vwx(w) : w
    }

    if (pw) {
      style.width = style.minWidth = `${pw}%`
    }

    if (h) {
      style.height = style.minHeight = isMobile ? vwx(h) : h
    }

    if (ph) {
      style.height = style.minHeight = `${ph}%`
    }

    return style
  }, [ isMobile, w, pw, ph, h ])

  const skeletonClassName = cx(className, {
    [s.circle]: circle,
    [s[color]]: color,
    [s.inline]: inline,
  })

  return (
    <div className={skeletonClassName} style={style}>
      {
        aspect && (
          <div style={{ paddingTop: `${Math.round(100 / aspect)}%` }} />
        )
      }
    </div>
  )
}


export default React.memo(Skeleton)
